import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    modalTarget: String,
    frameTarget: String
  }

  open(event) {
    event.preventDefault()
    const href = this.element.getAttribute("href")
    const frameId = this.frameTargetValue || this.element.dataset.turboFrame
    const modalId = this.modalTargetValue

    if (!frameId || !modalId) {
      return
    }

    const frame = document.getElementById(frameId)
    if (frame && href) {
      frame.src = href
    }

    const modalElement = document.getElementById(modalId)
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement)
      modal.show()
    }
  }
}

